module.exports = __webpack_public_path__ + "static/img/value_1.cfcaeea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/value_1.png
// module id = //EV
// module chunks = 1